'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shop: state.shops.shop
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(InfoDetail, _Component);

  function InfoDetail() {
    (0, _classCallCheck3.default)(this, InfoDetail);
    return (0, _possibleConstructorReturn3.default)(this, (InfoDetail.__proto__ || (0, _getPrototypeOf2.default)(InfoDetail)).apply(this, arguments));
  }

  (0, _createClass3.default)(InfoDetail, [{
    key: 'render',
    value: function render() {
      var styles = require('./Detail.scss');
      var shop = this.props.shop;

      return shop && shop.owner ? _react2.default.createElement(
        'div',
        {
          className: styles.contentTab + ' ' + styles.about,
          id: 'about',
          ref: 'about'
        },
        _react2.default.createElement(
          'div',
          { className: styles.headerTab },
          _react2.default.createElement(
            'h2',
            { className: styles.leftHeaderTab },
            _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'info-sign' }),
            'Gi\u1EDBi thi\u1EC7u'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyTab },
          _react2.default.createElement('p', {
            className: styles.pra,
            dangerouslySetInnerHTML: {
              __html: shop && shop.description ? shop.description : 'Thông tin shop chưa được cập nhập!'
            }
          })
        )
      ) : null;
    }
  }]);
  return InfoDetail;
}(_react.Component), _class2.propTypes = {
  shop: _react.PropTypes.object
}, _temp)) || _class);
exports.default = InfoDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Detail/InfoDetail.js
// module id = 1668
// module chunks = 0